var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 149.59,
    height: 149.59,
    viewBox: "0 0 149.59 149.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149.59,
    height: 149.59,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M149.589,74.8A74.8,74.8,0,1,1,74.794,0,74.795,74.795,0,0,1,149.589,74.8",
    transform: "translate(0 0)",
    fill: "#205583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.795,76.025A63.77,63.77,0,1,1,76.024,12.254a63.771,63.771,0,0,1,63.771,63.771",
    transform: "translate(-1.229 -1.229)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.873,140.994a65.12,65.12,0,1,1,65.12-65.119,65.194,65.194,0,0,1-65.12,65.119m0-127.541a62.421,62.421,0,1,0,62.421,62.421A62.492,62.492,0,0,0,75.873,13.453",
    transform: "translate(-1.079 -1.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.795,76.025A63.77,63.77,0,1,1,76.024,12.254a63.771,63.771,0,0,1,63.771,63.771",
    transform: "translate(-1.229 -1.229)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.873,140.994a65.12,65.12,0,1,1,65.12-65.119,65.194,65.194,0,0,1-65.12,65.119m0-127.541a62.421,62.421,0,1,0,62.421,62.421A62.492,62.492,0,0,0,75.873,13.453",
    transform: "translate(-1.079 -1.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.254,76.025a63.77,63.77,0,1,1,127.541,0Z",
    transform: "translate(-1.229 -1.229)",
    fill: "#205583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.994,77.224H10.753v-1.35a65.12,65.12,0,1,1,130.241,0Zm-127.527-2.7H138.28a62.422,62.422,0,0,0-124.814,0",
    transform: "translate(-1.079 -1.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.715,22.121a9.932,9.932,0,1,1-18.7-4.658,63.289,63.289,0,0,1,13.366-4.14,9.924,9.924,0,0,1,5.334,8.8",
    transform: "translate(-5.403 -1.337)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.633,33.244a11.277,11.277,0,0,1-9.96-16.572l.221-.415.431-.188A64.726,64.726,0,0,1,67.977,11.84l.462-.09.418.219a11.279,11.279,0,0,1-5.224,21.276M55.851,18.35a8.459,8.459,0,0,0-.8,3.613,8.582,8.582,0,1,0,12.955-7.379A62.094,62.094,0,0,0,55.851,18.35",
    transform: "translate(-5.252 -1.179)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.621,79.544H77.9V52.334l9.743-3.487,9.982,3.487Z",
    transform: "translate(-7.815 -4.901)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.82,80.734H76.4V51.224l11.087-3.968,11.338,3.96ZM79.1,78.035H96.121v-24.9l-8.628-3.013-8.4,3.007Z",
    transform: "translate(-7.664 -4.741)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.454,80.252V68.137a1.881,1.881,0,0,1,1.04-1.682l20.7-10.347a1.885,1.885,0,0,1,1.683,0l20.7,10.347a1.881,1.881,0,0,1,1.04,1.682V80.252Z",
    transform: "translate(-8.874 -5.609)",
    fill: "#205583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.811,81.452H86.954V67.987A3.214,3.214,0,0,1,88.742,65.1L109.436,54.75a3.251,3.251,0,0,1,2.89,0l20.7,10.347a3.212,3.212,0,0,1,1.786,2.89Zm-45.158-2.7h42.459V67.987a.535.535,0,0,0-.293-.475l-20.7-10.347a.541.541,0,0,0-.477,0l-20.7,10.347a.527.527,0,0,0-.294.475Z",
    transform: "translate(-8.724 -5.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.849,57.033a3.712,3.712,0,0,0-4.854-4.716A5.1,5.1,0,1,0,40.1,54.029a6.187,6.187,0,0,0,.537,12.353H54.015a4.711,4.711,0,0,0,.833-9.349",
    transform: "translate(-3.455 -4.742)",
    fill: "#205583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.866,67.581H40.488a7.561,7.561,0,0,1-7.554-7.552,7.482,7.482,0,0,1,5.4-7.214c-.02-.2-.031-.4-.031-.6a6.447,6.447,0,0,1,12.677-1.657,5.111,5.111,0,0,1,5.3,5.082q0,.154-.011.308a6.061,6.061,0,0,1-2.4,11.629M44.75,48.468A3.755,3.755,0,0,0,41,52.219a3.7,3.7,0,0,0,.225,1.217,1.349,1.349,0,0,1-1.157,1.787,4.838,4.838,0,0,0,.42,9.659H53.866a3.362,3.362,0,0,0,.595-6.671,1.351,1.351,0,0,1-1.035-1.777,2.355,2.355,0,0,0-3.094-3.009A1.35,1.35,0,0,1,48.5,52.18a3.761,3.761,0,0,0-3.745-3.712",
    transform: "translate(-3.304 -4.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 13.168,
    transform: "translate(42.287 61.476)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.699,
    height: 13.168,
    transform: "translate(40.938 61.476)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 13.464,
    transform: "translate(42.287 48.013)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.853,68.029a1.35,1.35,0,0,1-1.35-1.35V53.216a1.35,1.35,0,1,1,2.7,0V66.679a1.35,1.35,0,0,1-1.35,1.35",
    transform: "translate(-4.565 -5.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 4.243,
    y2: 2.842,
    transform: "translate(38.044 54.609)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.378,64.739a1.344,1.344,0,0,1-.75-.229l-4.243-2.841a1.349,1.349,0,1,1,1.5-2.242l4.243,2.841a1.349,1.349,0,0,1-.752,2.471",
    transform: "translate(-4.092 -5.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.243,
    y2: 2.842,
    transform: "translate(42.288 52.026)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.853,61.868A1.35,1.35,0,0,1,46.1,59.4l4.244-2.841a1.35,1.35,0,0,1,1.5,2.242L47.6,61.64a1.344,1.344,0,0,1-.75.229",
    transform: "translate(-4.565 -5.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.076,148.766h-2.7V135.673a27.373,27.373,0,0,0-27.343-27.342H16.96v-2.7H37.034a30.076,30.076,0,0,1,30.042,30.041Z",
    transform: "translate(-1.701 -10.597)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.565,146.722h-2.7v-7.633a17.365,17.365,0,0,0-17.345-17.346H22.5v-2.7H35.521a20.066,20.066,0,0,1,20.044,20.045Z",
    transform: "translate(-2.257 -11.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.765,
    height: 7.579,
    transform: "translate(95.538 67.065)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.806,83.321H106.041a1.35,1.35,0,0,1-1.35-1.35V74.393a1.35,1.35,0,0,1,1.35-1.35h12.765a1.35,1.35,0,0,1,1.35,1.35v7.579a1.35,1.35,0,0,1-1.35,1.35m-11.416-2.7h10.066v-4.88H107.39Z",
    transform: "translate(-10.503 -7.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.365,92.884H66.213a44.256,44.256,0,0,1,4.314,2.7h73.838Z",
    transform: "translate(-6.643 -9.319)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.9,108.441v-2.7H81.4c.69.876,1.355,1.771,1.978,2.7Z",
    transform: "translate(-8.166 -10.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.444,121.3v-2.7H88.711c.34.888.66,1.785.944,2.7Z",
    transform: "translate(-8.9 -11.899)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.775,134.158v-2.7H91.728c.085.892.138,1.793.168,2.7Z",
    transform: "translate(-9.203 -13.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.166,147.884h-2.7v-17.04A35.3,35.3,0,0,0,40.207,95.583H13.191v-2.7H40.207a38,38,0,0,1,37.958,37.96Z",
    transform: "translate(-1.323 -9.319)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon_2.aac5b16267ce185ced9c88042c2d7f74.svg";
export { ForwardRef as ReactComponent };